import { useFlag } from '@calendly/feature-check-react'
import { useSelector } from 'react-redux'

import { useNotetakerCoreUiVisible } from 'hooks/notetaker_visibility'
import { isAdminOrOwnerSelector } from 'selectors/current_user'

/** Notetaker page tabs under `?settings=ai_notetaker` (Callie is its own Features section). */
export const SETTINGS_MODAL_AI_TAB = Object.freeze({
  NOTETAKER: 'notetaker',
  NOTETAKER_ACCESS: 'notetaker_access',
})

const SETTINGS_MODAL_AI_TABS = Object.freeze([
  { slug: SETTINGS_MODAL_AI_TAB.NOTETAKER },
  { slug: SETTINGS_MODAL_AI_TAB.NOTETAKER_ACCESS },
])

export function getSettingsModalNotetakerTabs({
  showAdminNotetakerAccessTab = false,
  showNotetakerTab = true,
} = {}) {
  return SETTINGS_MODAL_AI_TABS.filter(({ slug }) => {
    if (slug === SETTINGS_MODAL_AI_TAB.NOTETAKER_ACCESS) return showAdminNotetakerAccessTab
    if (slug === SETTINGS_MODAL_AI_TAB.NOTETAKER) return showNotetakerTab
    return true
  })
}

export function normalizeSettingsModalAiTab(tab, ctx) {
  const tabs = getSettingsModalNotetakerTabs(ctx)
  return tabs.some(({ slug }) => slug === tab)
    ? tab
    : (tabs[0]?.slug ?? SETTINGS_MODAL_AI_TAB.NOTETAKER)
}

export function useShowSettingsModalAdminNotetakerAccess() {
  const isOwnerOrAdmin = useSelector(isAdminOrOwnerSelector)
  const isNotetakerAdminSettingsPageEnabled = useFlag('notetaker_admin_settings_page')

  return isOwnerOrAdmin && isNotetakerAdminSettingsPageEnabled
}

export function useShowSettingsModalNotetakerTab() {
  const { isVisible, isLoading } = useNotetakerCoreUiVisible({ legacyVisible: true })
  return isVisible || isLoading
}
